import { PencilSimpleIcon, TrashIcon } from "@phosphor-icons/react";
import { Fragment } from "react";
import { Menu, MenuPopover, MenuSeparator } from "@/components/ui/menu";
import { CustomMenuItem, type MenuItemConfig } from "@/components/ui/menu-item";
import type { DynamicFilterItem } from "@/store/news-feed/filters/dynamic-filters.slice";
import useNewsFeedFilters from "@/store/news-feed/filters/newsFeed-filter.slice";

type ArticleTagFilterListItemMenuProps = {
  item: DynamicFilterItem;
};

const ArticleTagFilterListItemMenu = ({
  item,
}: ArticleTagFilterListItemMenuProps) => {
  const setArticleTagId = useNewsFeedFilters((state) => state.setArticleTagId);
  const setArticleTagName = useNewsFeedFilters(
    (state) => state.setArticleTagName,
  );
  const setDeleteArticleTagModalOpen = useNewsFeedFilters(
    (state) => state.setDeleteArticleTagModalOpen,
  );
  const setEditArticleTagModalOpen = useNewsFeedFilters(
    (state) => state.setCreateEditArticleTagModalOpen,
  );

  const menuItems: MenuItemConfig[] = [
    {
      id: "rename-article-tag",
      icon: <PencilSimpleIcon className="text-gray-600" size={14} />,
      label: "Rename tag",
      separator: true,
      onClick: () => {
        setArticleTagId(item.id);
        setArticleTagName(item.label);
        setEditArticleTagModalOpen(true);
      },
    },
    {
      id: "delete-article-tag",
      icon: <TrashIcon className="text-red-750" size={14} />,
      label: "Delete tag",
      onClick: () => {
        setArticleTagId(item.id);
        setArticleTagName(item.label);
        setDeleteArticleTagModalOpen(true);
      },
    },
  ];

  return (
    <MenuPopover placement="right top" offset={0}>
      <Menu>
        {menuItems.map((menuItem) => (
          <Fragment key={menuItem.id}>
            <CustomMenuItem config={menuItem} />
            {menuItem.separator && <MenuSeparator className="mx-1" />}
          </Fragment>
        ))}
      </Menu>
    </MenuPopover>
  );
};

export default ArticleTagFilterListItemMenu;
